import { ReactNode } from 'react'

import { css } from '@emotion/react'

import Footer from '@/components/Footer'
import NavbarLang from '@/components/NavigationMenu/NavbarLang'
import ButtonToTop from '@/components/common/ButtonToTop'
import PopupOverlayView from '@/components/Popups/PopupOverlayView'

import { useIsMobile } from '@/utils/useMobile'

import { useMarket } from '@/utils/multi-markets/context'

import Spinner from '../common/SpinnerPage'
import FooterMobile from '../FooterMobile'

interface Props {
  children: ReactNode
  isLoading?: boolean
}

export function LandingLayout(props: Props) {
  const { children, isLoading = false } = props
  const { isMobile } = useIsMobile()
  const { market } = useMarket()

  return !isLoading ? (
    <>
      <div id="popup-wrapper" />
      <NavbarLang />
      <main css={wrapper}>{children}</main>
      {isMobile ? <FooterMobile /> : <Footer short />}
      <ButtonToTop />
      {market && market !== 'bh' && <PopupOverlayView />}
    </>
  ) : (
    <Spinner />
  )
}

const wrapper = css`
  flex: 1 0 auto;
  overflow: hidden;
`

export default LandingLayout
